import React from "react";

const Profile = () => {
    return (
        <div>
            <h1 className="text-base md:text-lg lg:text-xl xl:text-2xl font-semibold text-sky-400 dark:text-indigo-900 mb-2 md:mb-4">
                Profile
            </h1>
            <p>
                Informatics Engineering student at Tadulako University
                Interested in Programming, especially Web and Mobile Development
                and focusing on Front-End
            </p>
        </div>
    );
};

export default Profile;
